if (!customElements.get('quick-shop')) {
  class QuickShop extends HTMLElement {
    constructor() {
      super();

      this.productHandle = this.dataset.productHandle;

      this.select = this.querySelector('select');
      if (this.select) {
        this.select.addEventListener('change', ({ target }) => this.fetchQuickShop(target.value));
      }
    }

    async fetchQuickShop(variantId) {
      const price = this.querySelector('.price');

      try {
        const response = await fetch(
          `/products/${this.productHandle}?variant=${variantId}&view=price&view-variant=cart-upsell-item`
        );
        price.outerHTML = await response.text();
      } catch (error) {
        console.error(error);
      }
    }
  }

  window.QuickShop = QuickShop;
  customElements.define('quick-shop', QuickShop);
}
